import { CreditRequestCreate } from "../models/accounting/credit/credit-request-create";
import { BillingOnlySearchFilter } from "../models/accounting/billing-only/billing-only-search-filters";
import { FedexSearchFilter } from "../transportation/models/filters/fedex-search-filters";
import { InvoiceSearchFilters } from "../models/accounting/invoices/invoice-search-filters";
import { InvoiceTotals } from "../models/accounting/invoices/invoice-totals";
import { InvoiceRead } from "../models/accounting/shared/invoice-read";
import { InvoiceSearchResponse } from "../models/accounting/shared/invoice-search-response";
import { SearchOrderSummary } from "../models/ordering/search-order-summary";
import { PagedApiResult } from "../models/utilities/paged-request";
import { Api, ApiResponse, StatusCode } from "../utils/api";
import { ApiEndpoints, Routes } from "../utils/app-constants";
import { AppUtils } from "../utils/app-utils";
import { navigateToPage } from "../utils/history";
import { BaseService } from "./_base-service";

export class AccountingSvc extends BaseService {

    // #region Credit

    public createCredit = async (credit: CreditRequestCreate) => {
        if (credit) {
            try {
                this._showLoading();
                await Api.Post(
                    ApiEndpoints.ACCOUNTING_CREDIT, 
                    credit
                );

                this._showToast("Credit saved successfully", "success");
                navigateToPage(Routes.INVOICING_CREDITS);
            }
            catch (err) {
                this._handleError(err);
            }
        }

        this._hideLoading();
    }

    // #endregion

    // #region Invoice Search

    public searchInvoices = async (params : InvoiceSearchFilters)  : Promise<ApiResponse<InvoiceSearchResponse>> => {

        const response = new ApiResponse<InvoiceSearchResponse>();
        if (params) {

            this._showLoading();

            try {

                const invoiceSearchProm = Api.PagedGet(
                    InvoiceRead, 
                    AppUtils.convertFiltersToUrl(params.baseUrl, params),
                    params.paginationInfo
                );

                const invoiceTotalProm = Api.Get(
                    InvoiceTotals, 
                    AppUtils.convertFiltersToUrl(ApiEndpoints.ACCOUNTING_INVOICES_TOTALS_QUERY, params)
                );

                await Promise.all([invoiceSearchProm, invoiceTotalProm])
                    .then((results: any) => {
                        if (results[0] && results[1]) {
                            response.status = StatusCode.Success;

                            response.data = new InvoiceSearchResponse();
                            response.data.searches = results[0];
                            response.data.totals = results[1];
                        }
                    });
            }
            catch (err) {
                response.status = this._handleError(err);
            }
        }
    
        this._hideLoading();
        return response;
    }

    // #endregion

    // #region 

    public getFedexOrders = async (orderFilter : FedexSearchFilter) : Promise<ApiResponse<PagedApiResult<SearchOrderSummary>>> => {
        return await this.search(SearchOrderSummary, orderFilter);
    }
    
    public getBillingOnlyOrders = async (orderFilter : BillingOnlySearchFilter) : Promise<ApiResponse<PagedApiResult<SearchOrderSummary>>> => {
        return await this.search(SearchOrderSummary, orderFilter);
    }

    public invoiceBillingOnlyOrder = async (orderId : string)  : Promise<ApiResponse<boolean>> => {

        const response = new ApiResponse<boolean>();
        this._showLoading();

        try {
        
            const ret = await this._post(
                ApiEndpoints.ACCOUNTING_INVOICE_ORDER.formattify(orderId), 
                {}
            );

            if (ret.status === StatusCode.Success) {
                response.status = StatusCode.Success;
                response.data = true;
                this._showToast('The order was invoiced successfully', 'success');
            }
            else {
                response.data = false;
            }

        }
        catch (err) {
            response.status = this._handleError(err);
        }

        return response;
    }

    // //#endregion

}
